export default __webpack_public_path__ + "static/media/news50.7c5c99d5.jpg";